module.exports = __webpack_public_path__ + "static/14-2bfd583180a693f7da1d8bdfad49339d.jpg";